import {http, onSuccess, onFail} from './http';

export const episodeLikeToggle = (id, liked) =>
    http.request({method: liked ? 'POST' : 'DELETE', url: `/api/player/event/stream/episode/${id}/like`})
        .then(onSuccess, onFail);

export const episodeFavoriteToggle = (id, bookmark) =>
    http.request({method: bookmark ? 'POST' : 'DELETE', url: `/api/player/event/stream/episode/${id}/favorite`})
        .then(onSuccess, onFail);

export const getEpisodeFavoriteList = async (eventKey) =>
    http.get(`/api/player/event/${eventKey}/stream/episode/favoriteList`)
        .then(onSuccess, onFail);
